var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.61 122.88",
    width: 122.61,
    height: 122.88,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4,98.45c-2.53,0-4.91-1.02-6.71-2.82L4.16,57.57a9.45,9.45,0,0,1,0-13.37,9.44,9.44,0,0,1,13.37,0L47.4,70.47,104.07,13.8a9.44,9.44,0,0,1,13.37,0,9.45,9.45,0,0,1,0,13.37L54.1,95.63A9.45,9.45,0,0,1,47.4,98.45Z",
    fill: "#FF69B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/updateIcon.99fbe7b6fecd59cc5dc99b5cab0ac0aa.svg";
export { ForwardRef as ReactComponent };